export default "__VITE_ASSET__BqSmvhK4__"